import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";

class PlayersDataProvider extends BaseDataProvider {
  async getOne(resource, params) {
    const GET = gql`
          query {
            SeasonTeamPlayerByID(id:"${params.id}") {
              id
              sportCode
              person {
                id
                stableId
                firstName
                lastName
                middleInitial
                name
              }
              football {
                id
                passingCompletions
                passingAttempts
                passingYards
                passingTouchdowns
                passingInterceptions
                passingCompletionPercentage
                rushingAttempts
                rushingYards
                rushingTouchdowns
                rushingAverage
                receptions
                receivingYards
                receivingTouchdowns
                receivingAverage
                totalPoints
              }
              girlsvolleyball {
                id
                playerGameCount
                kills
                aces
                digs
                blocks
                assists
                killsPerGame
                acesPerGame
                digsPerGame
                blocksPerGame
                assistsPerGame
              }
              basketball {
                id
                playerGameCount
                totalPoints
                pointsAgainst
                rebounds
                assists
                threePointFieldGoals
                pointsPerGame
                pointsAgainstPerGame
                reboundsPerGame
                assistsPerGame
                threePointFieldGoalsPerGame
              }
              soccer {
                id
                playerGameCount
                totalGoals
                assists
                shutouts
              }
              baseball {
                id
                playerGameCount
                hits
                atBats
                runs
                doubles
                triples
                homeRuns
                runsBattedIn
                stolenBases
                battingAverage
                inningsPitched
                runsAllowed
                earnedRuns
                hitsAllowed
                basesOnBalls
                strikeouts
                pitchingWins
                pitchingLosses
                saves
                earnedRunAverage
              }
              jerseyNumber
              position
              additionalPositions
              yearCode
              team {
                team {
                  id
                  name
                }
                id
              }
              isActive
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      return { data: response.data.SeasonTeamPlayerByID };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async delete(resource, params) {
    let infoString = JSON.stringify({ id: params.id }).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    infoString = infoString.substring(1, infoString.length - 1).trim();
    const DESTROY_OBJECT = gql`
            mutation {
              DeleteSeasonTeamPlayerByID(${infoString}, deleteGamePlayers:true)
            }`;
    const response = await this.client.mutate({ mutation: DESTROY_OBJECT });
    if (!response) throw new Error("BAD:", JSON.stringify(response));
    return { data: params.previousData };
  }

  async create(resource, params) {
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    objectInfo.seasonTeam = objectInfo.season_team_id;
    delete objectInfo.season_team_id;
    objectInfo.person = objectInfo.person.id;
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    //console.log("PlayersDataProvider.create():" + objectString );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    objectString = objectString.replace(/yearCode:"([^"]*)"/, "yearCode:$1");
    const CREATE_OBJECT = gql`
          mutation {
            CreateSeasonTeamPlayer(${objectString}) {
              id
              sportCode
              person {
                id
                stableId
                firstName
                lastName
                middleInitial
                name
              }
              jerseyNumber
              position
              additionalPositions
              yearCode
              girlsvolleyball {
                id
              }
              football {
                id
              }
              basketball {
                id
              }
              soccer {
                id
              }
              baseball {
                id
              }
              team {
                team {
                  id
                  name
                }
                id
              }
              isActive
            }
          }`;
    const response = await this.client.mutate({ mutation: CREATE_OBJECT });
    return { data: response.data.CreateSeasonTeamPlayer };
  }

  async update(resource, params) {
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    delete objectInfo.__typename;
    delete objectInfo.person;
    delete objectInfo.team;
    delete objectInfo.sportCode;
    if (objectInfo.football) {
      delete objectInfo.football.id;
      delete objectInfo.football.__typename;
    }
    if (objectInfo.girlsvolleyball) {
      delete objectInfo.girlsvolleyball.id;
      delete objectInfo.girlsvolleyball.__typename;
    }
    if (objectInfo.basketball) {
      delete objectInfo.basketball.id;
      delete objectInfo.basketball.__typename;
    }
    if (objectInfo.soccer) {
      delete objectInfo.soccer.id;
      delete objectInfo.soccer.__typename;
    }
    if (objectInfo.baseball) {
      delete objectInfo.baseball.id;
      delete objectInfo.baseball.__typename;
    }
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    objectString = objectString.replace(/yearCode:"([^"]*)"/, "yearCode:$1");
    //console.log("PlayersDataProvider.update():objectString:", objectString);
    const MUTATION = gql`
          mutation {
            UpdateSeasonTeamPlayer(${objectString}) {
              id
              sportCode
              person {
                id
                stableId
                firstName
                lastName
                middleInitial
                name
              }
              jerseyNumber
              position
              additionalPositions
              yearCode
              football {
                id
                passingCompletions
                passingAttempts
                passingYards
                passingTouchdowns
                passingInterceptions
                passingCompletionPercentage
                rushingAttempts
                rushingYards
                rushingTouchdowns
                rushingAverage
                receptions
                receivingYards
                receivingTouchdowns
                receivingAverage
                totalPoints
              }
              girlsvolleyball {
                id
                playerGameCount
                kills
                aces
                digs
                blocks
                assists
                killsPerGame
                acesPerGame
                digsPerGame
                blocksPerGame
                assistsPerGame
              }
              basketball {
                id
                playerGameCount
                totalPoints
                pointsAgainst
                rebounds
                assists
                threePointFieldGoals
                pointsPerGame
                pointsAgainstPerGame
                reboundsPerGame
                assistsPerGame
                threePointFieldGoalsPerGame
              }
              soccer {
                id
                playerGameCount
                totalGoals
                assists
                shutouts
              }
              baseball {
                id
                playerGameCount
                hits
                atBats
                runs
                doubles
                triples
                homeRuns
                runsBattedIn
                stolenBases
                battingAverage
                inningsPitched
                runsAllowed
                earnedRuns
                hitsAllowed
                basesOnBalls
                strikeouts
                pitchingWins
                pitchingLosses
                saves
                earnedRunAverage
              }
              team {
                team {
                  id
                  name
                }
                id
              }
              isActive
            }
          }`;
    try {
      const response = await this.client.mutate({ mutation: MUTATION });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.UpdateSeasonTeamPlayer };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getManyReferencesBySchoolSportTeamSeason(resource, params) {
    const { sort } = params;
    const numericFields = ["jerseyNumber"];
    const fieldTranslations = {
      // Translate virtual name field to DB field to sort by last name
      "person.name": "person.lastName"
    };

    if (fieldTranslations[sort.field]) {
      sort.field = fieldTranslations[sort.field];
    }

    const playerSort = sort
      ? `{
        direction: ${sort.order},
        path: "${sort.field}",
        type: ${numericFields.includes(sort.field) ? "NUMERIC" : "ALPHABETIC"}
      }`
      : "";

    const GET = gql`
          query {
            SeasonTeamByID(id:"${params.id}") {
              id
              seasonCode
              sportCode
              players(sort:[${playerSort}]) {
                id
                sportCode
                person {
                  id
                  stableId
                  firstName
                  lastName
                  middleInitial
                  name
                }
                jerseyNumber
                position
                additionalPositions
                yearCode
                girlsvolleyball {
                  id
                }
                football {
                  id
                }
                basketball {
                  id
                }
                soccer {
                  id
                }
                baseball {
                  id
                }
                team {
                  id
                }
                isActive
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      const { players: data } = response.data.SeasonTeamByID;
      return { data: data, total: data.length };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getManyReferencesByPerson(resource, params) {
    const GET = gql`
          query {
            PersonByID(id:"${params.id}") {
              id
              name
              isStub
              seasonTeamPlayers {
                id
                jerseyNumber
                position
                additionalPositions
                yearCode
                isActive
                team {
                  id
                  seasonCode
                  sportCode
                  team {
                    school {
                      name
                    }
                  }
                }
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      const data = response.data.PersonByID.seasonTeamPlayers;
      return { data: data };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getManyReference(resource, params) {
    if (
      params.target === "school_sport_team_season_id" ||
      params.target === "school_sport_season_team_id"
    ) {
      return this.getManyReferencesBySchoolSportTeamSeason(resource, params);
    } else if (params.target === "person_id") {
      return this.getManyReferencesByPerson(resource, params);
    } else {
      throw new Error("BAD TARGET:" + params.target);
    }
  }
}

export default PlayersDataProvider;
